import { DETAIL_INFO } from 'components/detail/data';
import DetailBox from 'components/detail/DetailBox';
import * as React from 'react';

export interface INoteManagerProps {
  notesData: any;
}

export default function NoteManager({ notesData }: INoteManagerProps) {
  return (
    <div className="w-full flex gap-x-[30px]">
      <div className="flex w-full flex-col">
        <DetailBox title="Organization" detailRows={DETAIL_INFO.organization(notesData)} />
        <DetailBox title="Status DS" detailRows={DETAIL_INFO.status_ds(notesData)} />
        <DetailBox title="Stats DS" detailRows={DETAIL_INFO.stats_ds(notesData)} />
        <DetailBox title="Note Specifics" detailRows={DETAIL_INFO.note_specifics(notesData)} />
      </div>
      <div className="flex w-full flex-col">
        <div className="flex flex-col mb-[25px]">
          <DetailBox
            title="Clinician Messages"
            detailRows={DETAIL_INFO.clinician_message(notesData)}
          />
          <DetailBox title="Status CO" detailRows={DETAIL_INFO.status_co(notesData)} />
          <DetailBox title="Stats CO" detailRows={DETAIL_INFO.stats_co(notesData)} />
        </div>
        <DetailBox
          title="Clinician Specifics"
          detailRows={DETAIL_INFO.clinician_specific(notesData)}
        />
      </div>
    </div>
  );
}
